import { isProduction } from '../../../utilities/environmentUtilities';
import PlanPageConstants from './PlanPageConstants';

export const PurchaseOptionsMapping = isProduction() ? {
    // production ids

    // Main Pricing Cards

    getUnlimitedMonthlyOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '1582d04f-886a-4efe-a37c-0c6d032c1d69';
            case PlanPageConstants.CURRENCIES.EUR: return '96b79eb5-8b1b-41cf-aa63-1a78691fbbb3';
            case PlanPageConstants.CURRENCIES.GBP: return '68f7722a-580c-44ff-8690-2403520658fd';
        }
    },
    getUnlimitedYearlyOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '5d27389b-ece3-4c81-942d-1eccc90c4858';
            case PlanPageConstants.CURRENCIES.EUR: return 'e7c67adf-bdfb-40b5-b257-3264363d1562';
            case PlanPageConstants.CURRENCIES.GBP: return '237ae4e7-fdc8-410f-8a8c-f328d04dd964';
        }
    },
    getProMonthlyOptionId: (currency, videoQuality) => {
        switch (currency) {
            case PlanPageConstants.CURRENCIES.USD:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return 'be933b83-69de-407e-a9f5-7a9b59d26372';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return 'f4c7118c-263b-4500-8333-d631cdc50c75';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'ecd50ec1-c472-4582-a4bf-193c56039a98';
                }
            case PlanPageConstants.CURRENCIES.EUR:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '9e6a92a9-13f7-4114-a978-0ef327f4fac3';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '36aa1420-746e-425e-b012-be62256a06d9';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return '69766c35-96be-4569-9cc1-deb638ef387c';
                }
            case PlanPageConstants.CURRENCIES.GBP:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '7c205333-7d04-421f-ada9-2f293968678a';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '6bc2a616-0eac-420a-94c8-7b16b7ff7d72';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'e8453e07-4843-456a-9756-388414d76d6d';
                }
        }
    },
    getProYearlyOptionId: (currency, videoQuality) => {
        switch (currency) {
            case PlanPageConstants.CURRENCIES.USD:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return 'a12a110f-9283-4e2c-956d-45d700f7ef21';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '570ba55a-0976-4247-b1ba-41e49e092828';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'a9ffde8e-1e79-4561-9382-dd56c28b942c';
                }
            case PlanPageConstants.CURRENCIES.EUR:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '13a704ae-0959-4754-8972-b66bd1e0558c';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '4af49767-d4e4-4aba-8374-9aabe1562dee';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return '9ae8beb4-50b5-40ab-b156-d843bcffc7fb';
                }
            case PlanPageConstants.CURRENCIES.GBP:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '7aed7464-f2bd-4bbd-9a33-33b856c1ff57';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return 'a196f74b-7ae2-4352-aca6-3febd9e08076';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'd666b1d7-5d97-4614-943d-8f8e44039995';
                }
        }
    },

    // Single Video Box

    getSingleVideoHobbyistOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return 'a13e0303-1648-4209-8b2b-05eb650597bc';
            case PlanPageConstants.CURRENCIES.EUR: return 'e379d2fb-252f-41be-b087-1668e8f96ff9';
            case PlanPageConstants.CURRENCIES.GBP: return 'f553bd76-674c-4b14-a705-b2d893a91417';
        }
    },
    getSingleVideoProOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '053eb9ad-e0fd-46c5-a30c-c1cc5b4423bd';
            case PlanPageConstants.CURRENCIES.EUR: return '7a13eb7b-6ef9-4fc6-b7ca-00c70d7b5c11';
            case PlanPageConstants.CURRENCIES.GBP: return '8d58a7c8-ab10-42e4-88e6-fb9996fc9568';
        }
    },
    getSingleVideo4KOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return 'ccb73d3f-dcfb-4099-a50a-c9fc46ab4e81';
            case PlanPageConstants.CURRENCIES.EUR: return 'ab5ca574-3a11-41ea-b53a-8c1446a0e6ff';
            case PlanPageConstants.CURRENCIES.GBP: return '5f21b601-13ad-483e-a2d7-04e268b9b5ba';
        }
    },

    // Video Credit Dialog

    getVideoCreditOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '09395356-8d2e-4a77-9d31-2b7fb395ef0b';
            case PlanPageConstants.CURRENCIES.EUR: return '35b24476-37a0-40ca-bc1d-f90426f53c07';
            case PlanPageConstants.CURRENCIES.GBP: return '7d7dc0d4-5611-49d4-b030-f5c56b780b5a';
        }
    },
    get4KVideoCreditOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '49c118f2-51c7-4f93-a6f1-7f888076ed54';
            case PlanPageConstants.CURRENCIES.EUR: return '4ac2d785-b169-4293-891e-186882e5cbfd';
            case PlanPageConstants.CURRENCIES.GBP: return '59bc26e3-ed92-4238-833c-9a586f519246';
        }
    },
} : {
    // staging ids

    // Main Pricing Cards

    getUnlimitedMonthlyOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '3ba6c762-f5a1-4199-8971-8c4f7be1ef5e';
            case PlanPageConstants.CURRENCIES.EUR: return 'e6b7f41f-3a48-48f6-9a6d-b29d23ebc2ed';
            case PlanPageConstants.CURRENCIES.GBP: return 'a9f3b2e8-9836-4852-b3c2-72f7e2bcf542';
        }
    },
    getUnlimitedYearlyOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '7fa6d5c9-d76a-4c22-a8b2-63a7e58adf8c';
            case PlanPageConstants.CURRENCIES.EUR: return '6bd4fba5-d1a7-42cb-960d-d887c38467a4';
            case PlanPageConstants.CURRENCIES.GBP: return '4cbd88cf-899d-4b1e-938e-fd9e94f5c1fa';
        }
    },
    getProMonthlyOptionId: (currency, videoQuality) => {
        switch (currency) {
            case PlanPageConstants.CURRENCIES.USD:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '0f7647f6-3de1-45ab-9460-eb95e2130bc1';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '7660d9f8-4d7c-41b8-82fb-b6eb34ba6785';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'bc1ee95f-9be5-4913-8f86-4288f5d6a24a';
                }
            case PlanPageConstants.CURRENCIES.EUR:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '1d6185f8-4439-47cd-a0f7-acdbb4f6f012';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return 'bc39f6cc-4e0d-4022-b31f-a8ba7f8ef65e';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'f016d29c-50dd-475e-92bc-1a35d490ea69';
                }
            case PlanPageConstants.CURRENCIES.GBP:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '954fb38e-bf10-42eb-a7f2-333820c3f793';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '02100d10-d223-4360-93c1-7295caba1cf6';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return '8038dbc0-da88-4b16-9523-58bdae8b68d9';
                }
        }
    },
    getProYearlyOptionId: (currency, videoQuality) => {
        switch (currency) {
            case PlanPageConstants.CURRENCIES.USD:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '96f96f2f-4258-47e0-8351-3a9d0c95b410';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '0bb125e3-92ce-49f0-b187-df054d84e34b';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'ae32c35a-a08e-4df6-aca2-385ee65fcb7f';
                }
            case PlanPageConstants.CURRENCIES.EUR:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '1fd28781-6bfd-464a-8f8e-77983aba37b6';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return 'dcbb1f5a-e8d9-4188-b5c3-cc3ec7c31071';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return 'd8ea79ff-06c9-4f4d-bf7b-9bf0d12013f2';
                }
            case PlanPageConstants.CURRENCIES.GBP:
                switch (videoQuality) {
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS: return '41df54b1-0c20-4c20-9a16-e520164e79f6';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.SEVEN_TWENTY_P_30FPS: return '084d7967-f4ac-4f01-bfdf-fbbe5fd34ae1';
                    case PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.FOUR_K_60FPS: return '045bf973-b551-423a-ad14-7136d0b4ff16';
            }
        }
    },

    // Single Video Box

    getSingleVideoHobbyistOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return 'a13e0303-1648-4209-8b2b-05eb650597bc';
            case PlanPageConstants.CURRENCIES.EUR: return 'e379d2fb-252f-41be-b087-1668e8f96ff9';
            case PlanPageConstants.CURRENCIES.GBP: return 'f553bd76-674c-4b14-a705-b2d893a91417';
        }
    },
    getSingleVideoProOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '053eb9ad-e0fd-46c5-a30c-c1cc5b4423bd';
            case PlanPageConstants.CURRENCIES.EUR: return '7a13eb7b-6ef9-4fc6-b7ca-00c70d7b5c11';
            case PlanPageConstants.CURRENCIES.GBP: return '8d58a7c8-ab10-42e4-88e6-fb9996fc9568';
        }
    },
    getSingleVideo4KOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '7384782a-266f-4adc-aac2-2cb6c9383c7e';
            case PlanPageConstants.CURRENCIES.EUR: return '6f3b844b-019f-4a08-af26-e0936f3d69dc';
            case PlanPageConstants.CURRENCIES.GBP: return '7309144c-2861-44bb-b2b1-3736f30a94c7';
        }
    },

    // Video Credit Dialog

    getVideoCreditOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return '09395356-8d2e-4a77-9d31-2b7fb395ef0b';
            case PlanPageConstants.CURRENCIES.EUR: return '35b24476-37a0-40ca-bc1d-f90426f53c07';
            case PlanPageConstants.CURRENCIES.GBP: return '7d7dc0d4-5611-49d4-b030-f5c56b780b5a';
        }
    },
    get4KVideoCreditOptionId: (currency) => {
        switch (currency){
            case PlanPageConstants.CURRENCIES.USD: return 'ca6f869c-5fde-41a6-9005-2704d6371331';
            case PlanPageConstants.CURRENCIES.EUR: return 'e2a681f4-1f6c-4f59-9e0e-1dab23b58214';
            case PlanPageConstants.CURRENCIES.GBP: return 'eb566f1b-1677-4455-9810-403910c0c838';
        }
    },
};